var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormSelect',{attrs:{"disabled":_vm.readonly,"items":_vm.items,"label":_vm.label,"rules":_vm.rules},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }